export default {
  AUTHENTICATE: '@YOLA_EDITOR/AUTH/AUTHENTICATE',
  FETCH_TOKEN: '@YOLA_EDITOR/AUTH/FETCH_TOKEN',
  SET_SITE_ID: '@YOLA_EDITOR/AUTH/SET_SITE_ID',
};
